Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = PriceString;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _airbnbL10n = require('airbnb-l10n');

var _airbnbL10n2 = _interopRequireDefault(_airbnbL10n);

var _T = require('airbnb-i18n/T');

var _T2 = _interopRequireDefault(_T);

var _currency = require('../utils/propTypes/currency');

var _currency2 = _interopRequireDefault(_currency);

var _reasonableNumber = require('../utils/propTypes/reasonableNumber');

var _reasonableNumber2 = _interopRequireDefault(_reasonableNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var NAN_SYMBOL = '—'; // Unicode em-dash

var maybe = function maybe(fn) {
  return function (apply, value) {
    return apply ? fn(value) : value;
  };
};
var maybeHideZero = maybe(function (price) {
  return price === 0 ? NAN_SYMBOL : price;
});
var maybeRound = maybe(function (price) {
  return Math.round(price);
});

function priceString(_ref) {
  var price = _ref.price,
      currency = _ref.currency,
      code = _ref.code,
      thousandsDelimiter = _ref.thousandsDelimiter,
      round = _ref.round,
      hideZero = _ref.hideZero;

  return _airbnbL10n2['default'].priceString(maybeHideZero(hideZero, maybeRound(round, price)), currency, {
    code: code,
    thousandsDelimiter: thousandsDelimiter
  });
}

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
  price: _reasonableNumber2['default'].isRequired,
  currency: _currency2['default'].isRequired,
  code: _propTypes2['default'].bool,
  thousandsDelimiter: _propTypes2['default'].bool,
  round: _propTypes2['default'].bool,

  // For design reasons we don't want to show a $0 on previews if you haven't
  // set a price yet. Only used in P3/BookItPriceHeader
  hideZero: _propTypes2['default'].bool,

  // In some cases, we want to indicate that the price could be greater than or equal to the price,
  // but not all locales use "+" to indicate this, so in these cases we use a <T /> component.
  includePlus: _propTypes2['default'].bool
});

var defaultProps = {
  code: null,
  thousandsDelimiter: false,
  round: false,
  hideZero: false,
  includePlus: false
};

function PriceString(_ref2) {
  var price = _ref2.price,
      currency = _ref2.currency,
      code = _ref2.code,
      thousandsDelimiter = _ref2.thousandsDelimiter,
      round = _ref2.round,
      hideZero = _ref2.hideZero,
      includePlus = _ref2.includePlus;

  var priceStr = priceString({
    price: price,
    currency: currency,
    code: code,
    thousandsDelimiter: thousandsDelimiter,
    round: round,
    hideZero: hideZero
  });

  return includePlus ? _react2['default'].createElement(_T2['default'], { k: 'price_plus', price: priceStr, 'default': '%{price}+' }) :
  // eslint-disable-next-line airbnb/translation-require-default
  _react2['default'].createElement(_T2['default'], { t: priceStr, html: true });
}

PriceString.propTypes = propTypes;
PriceString.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/PriceString.js
// module id = 414
// module chunks = 168707334958949